import * as React from 'react';

const ShareForecastSuccessPopup = (props) => {
    const { SetStatus } = props;
    return (
        <>
            <div className="avnet-modal modal-630">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading ps-5">Forecast Shared</h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="text-center mb-3">
                            Your forecast has been shared successfully.
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-primary minw-auto"
                                onClick={() => {
                                    SetStatus(false)
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShareForecastSuccessPopup;